import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store, select} from '@ngrx/store';
import {Observable} from 'rxjs';
import {selectRouterUrl} from '../../../core/store/router/router.selector';
import {AuthenticationService} from 'src/app/auth/auth.service';
import {Router} from '@angular/router';

@Component({
  selector: 'desktop-layout',
  templateUrl: './desktop-layout.component.html',
  styleUrls: ['./desktop-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopLayoutComponent implements OnInit {
  routerUrl$: Observable<string>;

  public username: string;

  constructor(
    private store$: Store,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.routerUrl$ = this.store$.pipe(select(selectRouterUrl));
    this.username = JSON.parse(localStorage.getItem('currentUser')).username;
  }

  public onLogout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
